export { default } from "./Home"


// WEBPACK FOOTER //
// ./src/screens/Home/index.ts